// Network Types
// Canonical list of supported networks, in priority order — the first entry is the
// fallback default. NetworkType is derived from it so the type and the runtime list
// can't drift. Import the value from './commonTypes' directly (not the ../types
// barrel) in low-level modules, to avoid pulling the other type modules in.
export const NETWORKS = ['mainnet', 'testnet', 'devnet'];
